import React from "react";
import { useLanguage } from "../../Context/language";
import { toAbsoluteUrl } from "../../../_metronic/helpers";

function LanguageSelector() {
  const { language, setLanguage } = useLanguage();

  const baseButtonStyle = {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    padding: "8px 12px",
    border: "2px solid #dee2e6",
    borderRadius: "6px",
    background: "white",
    cursor: "pointer",
    transition: "all 0.3s ease",
    fontSize: "12px",
    fontWeight: "600",
    color: "#495057",
    textDecoration: "none",
  };

  const activeButtonStyle = {
    ...baseButtonStyle,
    borderColor: "#dc3545",
    background: "#dc3545",
    color: "white",
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        gap: "10px",
        margin: "15px 0",
      }}
    >
      <button
        type="button"
        style={language === "pt" ? activeButtonStyle : baseButtonStyle}
        onClick={() => setLanguage("pt")}
        title="Português"
        onMouseEnter={(e) => {
          if (language !== "pt") {
            e.currentTarget.style.borderColor = "#dc3545";
            e.currentTarget.style.background = "#f8f9fa";
            e.currentTarget.style.transform = "translateY(-1px)";
          }
        }}
        onMouseLeave={(e) => {
          if (language !== "pt") {
            e.currentTarget.style.borderColor = "#dee2e6";
            e.currentTarget.style.background = "white";
            e.currentTarget.style.transform = "translateY(0)";
          }
        }}
      >
        <img
          src={toAbsoluteUrl("/media/flags/brazil.svg")}
          alt="Português"
          width="20"
          height="20"
          style={{
            borderRadius: "2px",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.3)",
          }}
        />
        <span>BR</span>
      </button>

      <button
        type="button"
        style={language === "es" ? activeButtonStyle : baseButtonStyle}
        onClick={() => setLanguage("es")}
        title="Español"
        onMouseEnter={(e) => {
          if (language !== "es") {
            e.currentTarget.style.borderColor = "#dc3545";
            e.currentTarget.style.background = "#f8f9fa";
            e.currentTarget.style.transform = "translateY(-1px)";
          }
        }}
        onMouseLeave={(e) => {
          if (language !== "es") {
            e.currentTarget.style.borderColor = "#dee2e6";
            e.currentTarget.style.background = "white";
            e.currentTarget.style.transform = "translateY(0)";
          }
        }}
      >
        <img
          src={toAbsoluteUrl("/media/flags/paraguay.svg")}
          alt="Español"
          width="20"
          height="20"
          style={{
            borderRadius: "2px",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.3)",
          }}
        />
        <span>PY</span>
      </button>
    </div>
  );
}

export default LanguageSelector;
